import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// -------------------- IndexedDB Wrapper --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.database.IndexedDbWrapper.';
  public static readonly indexedDbWrapper_databaseAccessBlocked = `${Id.prefix}databaseAccessBlocked`;
  public static readonly indexedDbWrapper_closeTabs = `${Id.prefix}closeTabs`;
  public static readonly indexedDbWrapper_applicationUpdate = `${Id.prefix}applicationUpdate`;
  public static readonly indexedDbWrapper_reloadToContinue = `${Id.prefix}reloadToContinue`;
}

export class LangIndexedDbWrapper {
  private constructor() {}
  public static databaseAccessBlocked(): string {
    return interpolate(Id.indexedDbWrapper_databaseAccessBlocked);
  }
  public static closeTabs(): string {
    return interpolate(Id.indexedDbWrapper_closeTabs);
  }
  public static applicationUpdate(): string {
    return interpolate(Id.indexedDbWrapper_applicationUpdate);
  }
  public static reloadToContinue(): string {
    return interpolate(Id.indexedDbWrapper_reloadToContinue);
  }
}

export class IndexedDbWrapperModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.indexedDbWrapper_databaseAccessBlocked,
      'Database Access Blocked',
      'Title for blocked database access'
    );
    register.add(
      Id.indexedDbWrapper_closeTabs,
      'Please close all other browser tabs/windows accessing this page to continue',
      'Message for closing tabs to continue'
    );
    register.add(Id.indexedDbWrapper_applicationUpdate, 'Application Update', 'Title for application update');
    register.add(
      Id.indexedDbWrapper_reloadToContinue,
      'Please reload the page to continue',
      'Message for reloading page to continue'
    );
  }
}
